import React from "react";
import { Route, Navigate } from "react-router-dom";
import ProductList from "../feature-module/inventory/productlist";
import Dashboard from "../feature-module/dashboard/Dashboard";
import AddProduct from "../feature-module/inventory/addproduct";
import BrandList from "../feature-module/inventory/brandlist";
import CategoryList from "../feature-module/inventory/categorylist";
import InventoryList from "../feature-module/inventory/inventorylist";
import BatchList from "../feature-module/inventory/batches";
import PurchasesList from "../feature-module/purchases/purchaseslist";
import Customers from "../feature-module/people/customers";
import Suppliers from "../feature-module/people/suppliers";
import Pos from "../feature-module/sales/pos";
import SalesList from "../feature-module/sales/saleslist";
import Onboarding from "../feature-module/onboarding/Onboarding";
import Signin from "../feature-module/pages/login/signin";
import Register from "../feature-module/pages/register/register";
import ForgotPassword from "../feature-module/pages/login/forgot-password";
import Error404 from "../feature-module/pages/errorpages/error404";
import Error500 from "../feature-module/pages/errorpages/error500";
import Users from "../feature-module/usermanagement/users";
import { Units } from "../feature-module/inventory/units";

import { all_routes } from "./all_routes";
const routes = all_routes;

import Stores from "../feature-module/stores/liststores";
import AddStore from "../feature-module/stores/addStore";
import { AdminsPage as Administration } from "../pages/new/AdminsPage";
import EditStore from "../feature-module/stores/editStore";
import AddEmployee from "../feature-module/usermanagement/addEmployee";
import EditEmployee from "../feature-module/usermanagement/editEmployee";
import Designations from "../feature-module/usermanagement/designations";
import { RolesPage as Roles } from "../pages/new/RolesPage";
import CustomerGroups from "../feature-module/people/customerGroups";
import EditProduct from "../feature-module/inventory/editproduct";
import NewPurchase from "../feature-module/purchases/newPurchase";
import EditPurchase from "../feature-module/purchases/editPurchase";
import GRNList from "../feature-module/purchases/grn";
import NewGRN from "../feature-module/purchases/newGRN";
import EditGRN from "../feature-module/purchases/editGRN";
import Repairs from "../feature-module/repairs/repairs";
import ModelList from "../feature-module/inventory/models";
import RepairCategories from "../feature-module/repairs/repairCategories";
import RepairDashboard from "../feature-module/repairs/repairDashboard";
import AddRepairJob from "../feature-module/repairs/addRepair";
import RepairPOS from "../feature-module/repairs/RepairPOS";
import EditRepairJob from "../feature-module/repairs/editRepair";
import PredefinedRepairs from "../feature-module/repairs/predefinedRepairs";
import AddPredefinedRepair from "../feature-module/repairs/AddPredefinedRepair";
import EditPredefinedRepair from "../feature-module/repairs/EditPredefinedRepair";
import TenantSettings from "../feature-module/settings/tenantSettings";
import Tasks from "../feature-module/staff/tasks";
import SpecialParts from "../feature-module/repairs/specialParts";
import Media from "../feature-module/media/Media";
import Payments from "../feature-module/sales/payments";
import CartHistory from "../feature-module/sales/cartHistory";
import NewSale from "../feature-module/sales/newSale";
import OpeningStock from "../feature-module/inventory/openingStock";
import SerialTrack from "../feature-module/inventory/serialTrack";
import StockAdjustments from "../feature-module/stock/stockAdjustments";
import StockTransfers from "../feature-module/stock/stockTransfers";
import NewTransfer from "../feature-module/stock/newTransfer";
import EditTransfer from "../feature-module/stock/editTransfer";
import PendingApprovals from "../feature-module/stock/pendingApprovals";
import Expenses from "../feature-module/expenses/expenses";
import ExpensesCategory from "../feature-module/expenses/expensesCategory";
import { StockReport } from "../feature-module/reports/StockReport";
import { ExpenseReport } from "../feature-module/reports/ExpenseReport";
import { SalesSummaryReport } from "../feature-module/reports/SalesSummaryReport";
import { CustomerwiseSalesReport } from "../feature-module/reports/CustomerwiseSalesReport";
import { SupplierwiseExpensesReport } from "../feature-module/reports/SupplierwiseExpensesReport";
import { InventoryMovementReport } from "../feature-module/reports/InventoryMovementReport";
import { ProfitLossReport } from "../feature-module/reports/ProfitLossReport";
import { StockTransferReport } from "../feature-module/reports/StockTransferReport";
import { PartsUsageReport } from "../feature-module/reports/PartsUsageReport";
import { SerialBarcodeReport } from "../feature-module/reports/SerialBarcodeReport";
import { DailyCashBalanceReport } from "../feature-module/reports/DailyCashBalanceReport";
import { SalesInvoiceReport } from "../feature-module/reports/SalesInvoiceReport";
import QuotationsList from "../feature-module/sales/quotationsList";
import NewQuotation from "../feature-module/sales/newQuotation";
import EditQuotation from "../feature-module/sales/editQuotation";
import ConvertToSalePage from "../feature-module/sales/convertToSale";
import AddAssembleConfig from "../feature-module/inventory/assembleConfigs/AddAssembleConfig";
import AssembleConfigsList from "../feature-module/inventory/assembleConfigs/AssembleConfigsList";
import AssembleJobsList from "../feature-module/inventory/assembleJobs/AssembleJobsList";
import AddAssembleJob from "../feature-module/inventory/assembleJobs/AddAssembleJob";
import ConvertAssembleJobToSale from "../feature-module/inventory/assembleJobs/ConvertAssembleJobToSale";
import ConvertAssembleJobToQuotation from "../feature-module/inventory/assembleJobs/ConvertAssembleJobToQuotation";
import RecurringInvoicesList from "../feature-module/sales/recurringInvoices/recurringInvoicesList";
import NewRecurringInvoice from "../feature-module/sales/recurringInvoices/newRecurringInvoice";
import EditRecurringInvoice from "../feature-module/sales/recurringInvoices/editRecurringInvoice";
import WarrantyClaimsList from "../feature-module/warranty/warrantyList";
import AddWarrantyClaim from "../feature-module/warranty/addWarrantyClaim";
import WarrantyClaimDetail from "../feature-module/warranty/warrantyClaimDetail";
import PaymentMethods from "../feature-module/settings/paymentMethods";
import Printers from "../feature-module/settings/printers";
import Templates from "../feature-module/settings/templates";
import AddTemplate from "../feature-module/settings/addTemplate";
import EditTemplate from "../feature-module/settings/editTemplate";
import { hiddenRoutes } from "../config/profiles";

const allPublicRoutes = [
  {
    id: 1,
    path: routes.dashboard,
    name: "home",
    element: <Dashboard />,
    route: Route,
  },
  {
    id: 2,
    path: routes.productlist,
    name: "products",
    element: <ProductList />,
    permission: "product read",
    route: Route,
  },
  {
    id: 3,
    path: routes.addproduct,
    name: "products",
    element: <AddProduct />,
    permission: "product create",
    route: Route,
  },
  {
    id: 5,
    path: routes.brandlist,
    name: "brant",
    element: <BrandList />,
    permission: "brand read",
    route: Route,
  },
  {
    id: 6,
    path: routes.units,
    name: "unit",
    element: <Units />,
    route: Route,
  },
  {
    id: 60,
    path: routes.categorylist,
    name: "categorylist",
    element: <CategoryList />,
    permission: "category product read",
    route: Route,
  },
  {
    id: 65,
    path: routes.editproduct,
    name: "editproduct",
    element: <EditProduct />,
    permission: "product update",
    route: Route,
  },
  {
    id: 66,
    path: routes.serialtrack,
    name: "serialtrack",
    element: <SerialTrack />,
    route: Route,
  },
  {
    id: 68,
    path: routes.purchaselist,
    name: "purchaselist",
    element: <PurchasesList />,
    permission: "purchase order read",
    route: Route,
  },
  {
    id: 84,
    path: routes.customers,
    name: "customers",
    element: <Customers />,
    route: Route,
  },
  {
    id: 85,
    path: routes.suppliers,
    name: "suppliers",
    element: <Suppliers />,
    route: Route,
  },
  {
    id: 99,
    path: routes.pos,
    name: "pos",
    element: <Pos />,
    route: Route,
  },
  {
    id: 102,
    path: routes.saleslist,
    name: "saleslist",
    element: <SalesList />,
    permission: "sale read",
    route: Route,
  },
  {
    id: 104,
    path: routes.users,
    name: "users",
    element: <Users />,
    route: Route,
  },
  {
    id: 116,
    path: "*",
    name: "NotFound",
    element: <Navigate to="/" />,
    route: Route,
  },
  {
    id: 120,
    path: routes.storeList,
    name: "store-list",
    element: <Stores />,
    route: Route,
  },
  {
    id: 121,
    path: routes.administration,
    name: "administration",
    element: <Administration />,
    route: Route,
  },
  {
    id: 124,
    path: routes.newStore,
    name: "new-store",
    element: <AddStore />,
    route: Route,
  },
  {
    id: 125,
    path: routes.editStore,
    name: "edit-store",
    element: <EditStore />,
    route: Route,
  },
  {
    id: 126,
    path: routes.addEmployee,
    name: "add-employee",
    element: <AddEmployee />,
    route: Route,
  },
  {
    id: 127,
    path: routes.editEmployee,
    name: "edit-employee",
    element: <EditEmployee />,
    route: Route,
  },
  {
    id: 132,
    path: routes.designations,
    name: "designations",
    element: <Designations />,
    permission: "employee designations read",
    route: Route,
  },
  {
    id: 133,
    path: routes.roles,
    name: "roles",
    element: <Roles />,
    route: Route,
  },
  {
    id: 134,
    path: routes.customerGroups,
    name: "customer-groups",
    element: <CustomerGroups />,
    route: Route,
  },
  {
    id: 136,
    path: routes.newPurchase,
    name: "new-purchase",
    element: <NewPurchase />,
    permission: "purchase order create",
    route: Route,
  },
  {
    id: 137,
    path: routes.editPurchase,
    name: "edit-purchase",
    element: <EditPurchase />,
    permission: "purchase order update",
    route: Route,
  },
  {
    id: 138,
    path: routes.grn,
    name: "grn",
    element: <GRNList />,
    permission: "goods received note read",
    route: Route,
  },
  {
    id: 139,
    path: routes.addGrn,
    name: "add-grn",
    element: <NewGRN />,
    permission: "goods received note create",
    route: Route,
  },
  {
    id: 140,
    path: routes.editGrn,
    name: "edit-grn",
    element: <EditGRN />,
    permission: "goods received note update",
    route: Route,
  },
  {
    id: 141,
    path: routes.brandModels,
    name: "brand-models",
    element: <ModelList />,
    permission: "brand model read",
    route: Route,
  },
  {
    id: 142,
    path: routes.repairCategories,
    name: "repair-categories",
    element: <RepairCategories />,
    route: Route,
  },
  {
    id: 143,
    path: routes.repairDashboard,
    name: "repair-dashboard",
    element: <RepairDashboard />,
    route: Route,
  },
  {
    id: 144,
    path: routes.addRepair,
    name: "add-repair",
    element: <AddRepairJob />,
    permission: "repair job create",
    route: Route,
  },
  {
    id: 144.1,
    path: routes.editRepair,
    name: "edit-repair",
    element: <EditRepairJob />,
    permission: "repair job update",
    route: Route,
  },
  {
    id: 145,
    path: routes.predefinedRepairs,
    name: "predefined-repairs",
    element: <PredefinedRepairs />,
    route: Route,
  },
  {
    id: 145.1,
    path: routes.addPredefinedRepair,
    name: "add-predefined-repair",
    element: <AddPredefinedRepair />,
    route: Route,
  },
  {
    id: 145.2,
    path: routes.editPredefinedRepair,
    name: "edit-predefined-repair",
    element: <EditPredefinedRepair />,
    route: Route,
  },
  {
    id: 146,
    path: routes.tenantSettings,
    name: "tenant-settings",
    element: <TenantSettings />,
    route: Route,
  },
  {
    id: 147,
    path: routes.tasks,
    name: "tasks",
    element: <Tasks />,
    permission: "task read",
    route: Route,
  },
  {
    id: 148,
    path: routes.specialParts,
    name: "special-parts",
    element: <SpecialParts />,
    route: Route,
  },
  {
    id: 149,
    path: routes.media,
    name: "media",
    element: <Media />,
    permission: ["media read", "media library view"],
    route: Route,
  },
  {
    id: 150,
    path: routes.payments,
    name: "payments",
    element: <Payments />,
    route: Route,
  },
  {
    id: 151,
    path: routes.cartHistory,
    name: "cart-history",
    element: <CartHistory />,
    route: Route,
  },
  {
    id: 152,
    path: routes.newSale,
    name: "new-sale",
    element: <NewSale />,
    permission: "sale create",
    route: Route,
  },
  {
    id: 153,
    path: routes.inventoryList,
    name: "inventory-list",
    element: <InventoryList />,
    permission: "inventory read",
    route: Route,
  },
  {
    id: 1531,
    path: routes.inventoryTransactions,
    name: "inventory-transactions",
    element: <Navigate to={routes.productlist} replace />,
    route: Route,
  },
  /* 
  {
    id: 301,
    path: routes.inventoryBatches,
    name: "inventory-batches",
    element: <BatchList />,
    route: Route,
  },
  */
  {
    id: 154,
    path: routes.openingStock,
    name: "opening-stock",
    element: <OpeningStock />,
    permission: "inventory serial create",
    route: Route,
  },
  {
    id: 155,
    path: routes.stockadjustment,
    name: "stock-adjustments",
    element: <StockAdjustments />,
    route: Route,
  },
  {
    id: 1551,
    path: routes.stocktransfer,
    name: "stock-transfers",
    element: <StockTransfers />,
    route: Route,
  },
  {
    id: 1552,
    path: routes.newTransfer,
    name: "new-transfer",
    element: <NewTransfer />,
    route: Route,
  },
  {
    id: 1553,
    path: routes.editTransfer,
    name: "edit-transfer",
    element: <EditTransfer />,
    route: Route,
  },
  {
    id: 156,
    path: routes.pendingApprovals,
    name: "pending-approvals",
    element: <PendingApprovals />,
    route: Route,
  },
  {
    id: 156,
    path: routes.expenses,
    name: "expenses",
    element: <Expenses />,
    route: Route,
  },
  {
    id: 157,
    path: routes.expensecategory,
    name: "expenses-categories",
    element: <ExpensesCategory />,
    route: Route,
  },
  {
    id: 158,
    path: routes.storeList,
    name: "stores",
    element: <Stores />,
    route: Route,
  },
  {
    id: 159,
    path: routes.newStore,
    name: "new-store",
    element: <AddStore />,
    route: Route,
  },
  {
    id: 160,
    path: routes.editStore,
    name: "edit-store",
    element: <EditStore />,
    route: Route,
  },
  {
    id: 161,
    path: routes.stockReports,
    name: "stock-reports",
    element: <StockReport />,
    permission: "report product stock view",
    route: Route,
  },
  {
    id: 1611,
    path: routes.expenseReports,
    name: "expense-reports",
    element: <ExpenseReport />,
    permission: "report expense view",
    route: Route,
  },
  {
    id: 162,
    path: routes.salesSummaryReport,
    name: "sales-summary-report",
    element: <SalesSummaryReport />,
    permission: "report sales summary view",
    route: Route,
  },
  {
    id: 1621,
    path: routes.customerwiseSalesReport,
    name: "customerwise-sales-report",
    element: <CustomerwiseSalesReport />,
    permission: "report customerwise sales view",
    route: Route,
  },
  {
    id: 1622,
    path: routes.supplierwiseExpenseReport,
    name: "supplierwise-expense-report",
    element: <SupplierwiseExpensesReport />,
    permission: "report supplierwise expense view",
    route: Route,
  },
  {
    id: 1623,
    path: routes.inventoryMovementReport,
    name: "inventory-movement-report",
    element: <InventoryMovementReport />,
    permission: "report inventory movement view",
    route: Route,
  },
  {
    id: 1624,
    path: routes.profitLossReport,
    name: "profit-loss-report",
    element: <ProfitLossReport />,
    permission: "report profit loss view",
    route: Route,
  },
  {
    id: 1625,
    path: routes.stockTransferReport,
    name: "stock-transfer-report",
    element: <StockTransferReport />,
    permission: "report stock transfer list view",
    route: Route,
  },
  {
    id: 1626,
    path: routes.salesInvoiceReport,
    name: "sales-invoice-report",
    element: <SalesInvoiceReport />,
    permission: "report sales invoice list view",
    route: Route,
  },
  {
    id: 163,
    path: routes.partsUsageReport,
    name: "parts-usage-report",
    element: <PartsUsageReport />,
    permission: "report parts usage view",
    route: Route,
  },
  {
    id: 169,
    path: routes.serialBarcodeReport,
    name: "serial-barcode-report",
    element: <SerialBarcodeReport />,
    permission: "report serial barcode view",
    route: Route,
  },
  {
    id: 170,
    path: routes.dailyCashBalanceReport,
    name: "daily-cash-balance-report",
    element: <DailyCashBalanceReport />,
    permission: "report daily cash balance view",
    route: Route,
  },
  {
    id: 166,
    path: routes.quotationsList,
    name: "quotations",
    element: <QuotationsList />,
    permission: "quotation read",
    route: Route,
  },
  {
    id: 167,
    path: routes.newQuotation,
    name: "new-quotation",
    element: <NewQuotation />,
    permission: "quotation create",
    route: Route,
  },
  {
    id: 168,
    path: routes.editQuotation,
    name: "edit-quotation",
    element: <EditQuotation />,
    permission: "quotation update",
    route: Route,
  },
  {
    id: 170,
    path: routes.convertToSale,
    name: "convert-to-sale",
    element: <ConvertToSalePage />,
    permission: "quotation convert",
    route: Route,
  },
  {
    id: 171,
    path: routes.addAssembleConfig,
    name: "add-assemble-config",
    element: <AddAssembleConfig />,
    permission: "assemble config create",
    route: Route,
  },
  {
    id: 172,
    path: routes.editAssembleConfig,
    name: "edit-assemble-config",
    element: <AddAssembleConfig />,
    permission: "assemble config update",
    route: Route,
  },
  {
    id: 173,
    path: routes.assembleConfigs,
    name: "assemble-configs",
    element: <AssembleConfigsList />,
    permission: "assemble config read",
    route: Route,
  },
  {
    id: 174,
    path: routes.addAssembleJob,
    name: "add-assemble-job",
    element: <AddAssembleJob />,
    permission: "assemble job create",
    route: Route,
  },
  {
    id: 175,
    path: routes.editAssembleJob,
    name: "edit-assemble-job",
    element: <AddAssembleJob />,
    permission: "assemble job update",
    route: Route,
  },
  {
    id: 176,
    path: routes.assembleJobs,
    name: "assemble-jobs",
    element: <AssembleJobsList />,
    permission: "assemble job read",
    route: Route,
  },
  {
    id: 177,
    path: routes.convertAssembleJobToSale,
    name: "convert-assemble-job-to-sale",
    element: <ConvertAssembleJobToSale />,
    permission: "assemble job process",
    route: Route,
  },
  {
    id: 177.1,
    path: routes.convertAssembleJobToQuotation,
    name: "convert-assemble-job-to-quotation",
    element: <ConvertAssembleJobToQuotation />,
    permission: "assemble job process",
    route: Route,
  },
  {
    id: 178,
    path: routes.recurringInvoices,
    name: "recurring-invoices",
    element: <RecurringInvoicesList />,
    permission: "recurring invoice read",
    route: Route,
  },
  {
    id: 179,
    path: routes.newRecurringInvoice,
    name: "new-recurring-invoice",
    element: <NewRecurringInvoice />,
    permission: "recurring invoice create",
    route: Route,
  },
  {
    id: 180,
    path: routes.editRecurringInvoice,
    name: "edit-recurring-invoice",
    element: <EditRecurringInvoice />,
    permission: "recurring invoice update",
    route: Route,
  },
  {
    id: 181,
    path: routes.warrantyClaims,
    name: "warranty-claims",
    element: <WarrantyClaimsList />,
    permission: "warranty claim read",
    route: Route,
  },
  {
    id: 182,
    path: routes.addWarrantyClaim,
    name: "add-warranty-claim",
    element: <AddWarrantyClaim />,
    permission: "warranty claim create",
    route: Route,
  },
  {
    id: 183,
    path: routes.warrantyClaimDetail,
    name: "warranty-claim-detail",
    element: <WarrantyClaimDetail />,
    permission: "warranty claim read",
    route: Route,
  },
  {
    id: 184,
    path: routes.paymentMethods,
    name: "payment-methods",
    element: <PaymentMethods />,
    permission: "payment-method read",
    route: Route,
  },
  {
    id: 185,
    path: routes.printers,
    name: "printers",
    element: <Printers />,
    permission: "printer read",
    route: Route,
  },
  {
    id: 186,
    path: routes.templates,
    name: "templates",
    element: <Templates />,
    permission: "template read",
    route: Route,
  },
  {
    id: 187,
    path: routes.addTemplate,
    name: "add-template",
    element: <AddTemplate />,
    permission: "template create",
    route: Route,
  },
  {
    id: 188,
    path: routes.editTemplate,
    name: "edit-template",
    element: <EditTemplate />,
    permission: ["template read", "template update"],
    route: Route,
  },
];

export const publicRoutes = allPublicRoutes.filter(
  (r) => !hiddenRoutes.has(r.name),
);

const allPosRoutes = [
  {
    id: 1,
    path: routes.pos,
    name: "pos",
    element: <Pos />,
    route: Route,
    permission: ["cart read", "cart create"],
  },
  {
    id: 2,
    path: routes.repairs,
    name: "repairs",
    element: <Repairs />,
    permission: "repair job read",
    route: Route,
  },
  {
    id: 3,
    path: routes.repairPos,
    name: "repair-pos",
    element: <RepairPOS />,
    permission: [
      "repair job read",
      "repair job add_payment",
      "predefined repair job read",
    ],
    route: Route,
  },
];

export const posRoutes = allPosRoutes.filter((r) => !hiddenRoutes.has(r.name));

export const onboardingRoute = [
  {
    id: 1,
    path: routes.onboarding,
    name: "onboarding",
    element: <Onboarding />,
    route: Route,
  },
];

export const pagesRoute = [
  {
    id: 1,
    path: routes.signin,
    name: "signin",
    element: <Signin />,
    route: Route,
  },
  {
    id: 4,
    path: routes.register,
    name: "register",
    element: <Register />,
    route: Route,
  },
  {
    id: 5,
    path: routes.forgotPassword,
    name: "forgotPassword",
    element: <ForgotPassword />,
    route: Route,
  },
  {
    id: 18,
    path: routes.error404,
    name: "error404",
    element: <Error404 />,
    route: Route,
  },
  {
    id: 19,
    path: routes.error500,
    name: "error500",
    element: <Error500 />,
    route: Route,
  },
];
